import React, { useState, useContext, useEffect, useCallback } from "react";
import { AppContext, DispatchContext } from '../../AppContext';
import TitleBar from '../../components/titleBar';
import { withStyles } from "@material-ui/core/styles";
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import ReportPropertiesForm from "../../components/ReportPropertiesForm";
import TextFieldPanel from "../../components/TextFieldPanel";
import EditSharpIcon from '@material-ui/icons/EditSharp';
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import AutoExcludeSourcesDialog from "../../components/AutoExcludeSourcesDialog";
import AutoAcceptSourcesDialog from "../../components/AutoAcceptSourcesDialog";
import Service from "../../services/service"
import * as actions from '../../actions/actions';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import IconButton from '@material-ui/core/IconButton';
import PublicIcon from '@material-ui/icons/Public';
import LibraryBooksSharpIcon from "@material-ui/icons/LibraryBooksSharp";
import SearchIcon from '@material-ui/icons/Search';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { ReactComponent as CoinsIcon } from '../../assets/coins.svg';
import LoadingScreen from '../../components/LoadingScreen';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import NewProjectForm from "../../components/NewProjectForm";
import ProjectsDialog from "../../components/ProjectsDialog";
import EditIcon from '@material-ui/icons/Edit';
import { resolveNotificationMessage } from '../../helpers/constants';
import { ReactComponent as UploadingIcon } from '../../assets/icons/uploading.svg';
import { ReactComponent as DownloadIcon } from '../../assets/icons/download.svg';
import { ReactComponent as ClipboardIcon } from '../../assets/icons/clipboard.svg';
import { ReactComponent as BooksIcon } from '../../assets/icons/books.svg';


const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    position: "relative",
  },
  main_container: {
    display: 'flex',
    height: '100%',
    flex: "1 1 auto",
    overflow: 'hidden',
    overflowX: 'auto',
  },
  selectSourcesPanel: {
    flex: "0 0 auto",
    width: 320,
    minWidth: 320,
    backgroundColor: "white",
  },
  centerPanel: {
    flex: '1 1 auto',
    padding: theme.spacing(1)
  },
  detailsPanel: {
    flex: "0 0 auto",
    flexDirection: "column",
    width: 350,
    minWidth: 350,
    backgroundColor: "white",
    display: "flex",
    overflowY: "auto",
  },
  startSearchPanel: {
    flex: "0 0 auto",
    padding: theme.spacing(1),
    textAlign: "center",

  },
  centerAlign: {
    textAlign: "center"
  },
  button: {
    width: "100%"
  },
  button_size: {
    width: '100%',
    height: "80px",
  },
  data: {
    paddingTop: "15px",
    paddingLeft: "11px"
  },
  expansion_details: {
    padding: "16px !important",
  },
  update_padding: {
    padding: 0,
  },
  pannelSummary: {
    padding: "0 16px",
  },
  propertiesPanel: {
    flex: "1 1 auto",
    minHeight: 0,
    height: 0,
    overflowY: "auto",
    padding: theme.spacing(1),
  },
  ToggleSourcesButtons: {
    width: "100%",
    padding: theme.spacing(2),
  },
  toggleButtonSize: {
    height: "80px",
    color: theme.palette.primary.main,
    display: "flex",
    justifyContent: "start"
  },

  selectedToggleButton: {
    color: theme.palette.primary.main + " !important",
  },

  button_overlay: {
    position: 'relative'
  },
  alignInRow: {
    display: "flex"
  },
  publicIcon: {
    marginRight: "5px",
    color: "#0D4A81"
  },
  notInterestedIcon: {
    margin: "0 0 -5px 0",
  },
  checkCircleIcon: {
    color: "#017d01",
    margin: "0 0 -5px 0",
  },
}))

function CreditsPanel() {

  const state = useContext(AppContext);
  const s = state.strings;
  const dispatch = useContext(DispatchContext);

  const onScanCreditsButtonClicked = () => {
    dispatch(actions.openPaymentDialog(true));
  }

  const requiredCredits = state.newCheckSettings.revisionReportId ? 0 : state.creditCosts.credits;
  const licenseCredits = (state.user.license.remaining == -1) ? 999999 : (state.user.license.remaining || 0);
  const availableCredits = state.user.credits + licenseCredits;
  const color = (requiredCredits > availableCredits) ? "#BB0000" : "#009900"; 
  return (
    <Button onClick={onScanCreditsButtonClicked} disabled={availableCredits >= requiredCredits} style={{backgroundColor: color, color:"white", width: "100%", height: 40}}>
      {s.common.scanCreditsCount.format(requiredCredits)}
    </Button>
  );
}

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);


const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    width: "100%",
    backgroundColor: '#ffffff',
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "#F7F7F7",
    borderBottom: "1px solid #E6E6E6",
    marginBottom: -1,
    minHeight: 40,
    height: 40,
    "&$expanded": {
      minHeight: 40,
      height: 40,
      backgroundColor: "#E6E6E6",
    },
    '&:hover': {
      cursor: "pointer",
      backgroundColor: "#EEEEEE",
      transition: 'background-color 0.2s',
    },
  },

  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const newPlagiarismTab = [
  { id: "upload", icon: <UploadingIcon fill="#0D4A81" height={50} width={50} style={{ margin: 16 }} /> },
  { id: "text", icon: <ClipboardIcon fill="#0D4A81" height={50} width={50} style={{ margin: 16 }} /> },
  { id: "download", icon: <DownloadIcon fill="#0D4A81" height={50} width={50} style={{ margin: 16 }} /> },
  { id: "library", icon: <BooksIcon fill="#0D4A81" height={50} width={50} style={{ margin: 16 }} /> }
];

export default function NewPlagiarismCheck() {
  const state = useContext(AppContext);
  const s = state.strings;
  const classes = useStyles(state);
  const dispatch = useContext(DispatchContext);
  const [openProjectsDialog, setOpenProjectsDialog] = useState(false);
  const [expanded, setExpanded] = React.useState("panel1");

  const changePanel = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const [loadingScreen, setLoadingScreen] = useState(false);

  useEffect(() => {

    dispatch(actions.resetNewCheckSettings());

    if (state.newCheckSettings.revisionReportId) {
      Service.getReport(state.newCheckSettings.revisionReportId, true).then(res => {    // load details for new active report, this updates the details panel
        const propertiesData = {
          title: s.newCheck.revisionTitlePrefix.format(res.data.Name),
          author: res.data.Author,
          projectid: res.data.ProjectId,
          comment: res.data.Comment,
        };
        // set reveionReportData and also restore revisionReportId, this has been deleted by previous resetNewCheckSettings()
        dispatch(actions.setNewCheckSettings({ source: "text", text: res.data.Text, revisionReportId: state.newCheckSettings.revisionReportId }));
        dispatch(actions.setDraftReport(propertiesData))
      });
    }

    dispatch(actions.setUI({ plagCheckMenuExpanded: true }));
    if (state.ui.pageName !== window.location.pathname) {
      dispatch(actions.navigate_to(window.location.pathname));
    }


    return () => {
      setLoadingScreen(false);
    };
  }, []);

  useEffect(() => {
    updateCreditCosts();
  }, [JSON.stringify(state.newCheckSettings), JSON.stringify(state.uploadedFilesStatus)]);

  const textChanged = useCallback((text) => {
    dispatch(actions.setNewCheckSettings({ text: text }));
  });

  // close projects dialog
  const closeProjectsDialog = () => {
    setOpenProjectsDialog(false);
  }

  // to change the active toggle button
  const changeToggleButton = (e, newSource) => {
    if (newSource) {
      if ((state.newCheckSettings.text && state.newCheckSettings.text.trim() !== '') ||
        (state.newCheckSettings.source == 'upload' && state.uploadedFiles.length > 0) ||
        (state.newCheckSettings.source == 'library' && (state.newCheckSettings.libraryTexts.length > 0))
      ) {
        dispatch(actions.openConfirmationDialog({
          title: s.newCheck.changeInputSource,
          text: s.newCheck.changeInputSourceHint,
          onConfirm: () => onConfirmChangeSource(newSource),
        }));
        return false;
      }
      onConfirmChangeSource(newSource);
    }
  }

  const onConfirmChangeSource = (newSource) => {
    dispatch(actions.setNewCheckSettings({ source: newSource, text: '', libraryTexts: [] }));
  }

  // start plagiarism check by NewPlagCheck()
  const startPlagiarism = () => {

    setLoadingScreen(true);

    let apiData = {
      web: state.newCheckSettings.searchWeb,
      lib: state.newCheckSettings.searchLib,
      author: state.draftReport.Author,
      comment: state.draftReport.Comment,
      projectid: state.draftReport.ProjectId,
      name: state.draftReport.Name,
      acceptedurls: state.newCheckSettings.acceptUrlPatterns,
      excludedurls: state.newCheckSettings.excludeUrlPatterns,
      usewhitelist: state.newCheckSettings.excludeByWhitelist,
      extractlinks: state.newCheckSettings.acceptCitedUrls,
      addtolibrary: state.newCheckSettings.addToLibrary,
      templatereportid: state.newCheckSettings.revisionReportId,
      hold: false
    };

    // in case chosen projects are defined, but NOT all are selected (because this is default and does not need to be stated explicitely)
    if ((state.newCheckSettings.searchInLibraryProjects.length > 0) && ((state.projects.length + 1) != state.newCheckSettings.searchInLibraryProjects.length)) {
      apiData.searchinprojectids = state.newCheckSettings.searchInLibraryProjects.map(({ Id }) => parseInt(Id));
    }

    switch (state.newCheckSettings.source) {
      case 'text':
      case 'download':
        apiData = { ...apiData, text: state.newCheckSettings.text };
        break;
      case 'library':
        apiData = { ...apiData, libtextids: state.newCheckSettings.libraryTexts.map(elem => elem.Id) };
        break;
      case 'upload':
        apiData = { ...apiData, uploadids: state.uploadedFilesStatus.filter(file => file.Status == "Ok").map(file => file.UploadId) };
        break;
    }

    Service.NewPlagCheck(apiData).then(res => {
      setLoadingScreen(false);
      if (res.success) {
        dispatch(actions.setDraftReport({}));
        dispatch(actions.navigate_to('/plagiarism/reports'));
        if (res.message) {
          dispatch(actions.openToast({ type: "warning", message: resolveNotificationMessage(res.message, s.notificationMessage) }));
        } else {
          dispatch(actions.openToast({ message: s.notificationMessage.plagScanStarted }));
        }
      } else {
        dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage) }));
      }
    })
  }

  // for add to library checkbox
  const addToLibrary = (checked) => {
    dispatch(actions.setNewCheckSettings({ addToLibrary: checked }));
  }

  // for calling calculatedCredits api when checkboxes clicked 
  const handlesourceCheckbox = (key, value, keyName) => {
    let newCheckSettings = {};
    if (key === 'checkedOnlineSources') {
      newCheckSettings = { ...newCheckSettings, searchWeb: value };
      if (!value && !state.newCheckSettings.searchLib) { // Switching off online source and library sources are already off
        // switch on library sources and init selected library projects
        newCheckSettings = { ...newCheckSettings, searchLib: true };
        newCheckSettings = { ...newCheckSettings, searchInLibraryProjects: [{ Id: 0, Name: '[Unassigned library texts]' }, ...state.projects] || [] };
      }
    }
    if (key === 'checkedLibrarySources') {
      newCheckSettings = { ...newCheckSettings, searchLib: value };
      if (value) {
        newCheckSettings = { ...newCheckSettings, searchInLibraryProjects: [{ Id: 0, Name: '[Unassigned library texts]' }, ...state.projects] || [] };
      } else {
        newCheckSettings = { ...newCheckSettings, searchInLibraryProjects: [] };
        newCheckSettings = { ...newCheckSettings, searchWeb: true };
      }
    }
    dispatch(actions.setNewCheckSettings(newCheckSettings));
  }


  const updateCreditCosts = () => {
    let apiData = { web: state.newCheckSettings.searchWeb, lib: state.newCheckSettings.searchLib };
    switch (state.newCheckSettings.source) {
      case 'text':
      case 'download':
        apiData = { ...apiData, text: state.newCheckSettings.text };
        break;
      case 'library':
        apiData = { ...apiData, libtextids: state.newCheckSettings.libraryTexts.map(elem => elem.Id) };
        break;
      case 'upload':
        apiData = { ...apiData, uploadids: state.uploadedFilesStatus.filter(file => file.Status == "Ok").map(file => file.UploadId) };
        break;
    }
    Service.calculateCredits(apiData).then(res => {
      if (!res.success) {
        dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage), status: true }));
      }
      dispatch(actions.setCreditCosts(res.data));
    });
  };

  const handleAutoExcludeUrlsChecked = (checked) => {
    if (checked) {
      dispatch(actions.setNewCheckSettings({ excludeByWhitelist: true }));
    } else {
      dispatch(actions.setNewCheckSettings({ excludeUrlPatterns: [], excludeByWhitelist: false }));
    }
  }

  const handleAcceptCitedUrlsChecked = (checked) => {
    if (checked) {
      dispatch(actions.setNewCheckSettings({ acceptCitedUrls: true }));
    } else {
      dispatch(actions.setNewCheckSettings({ acceptUrlPatterns: [], acceptCitedUrls: false }));
    }
  }

  let startPlagiarismStatus = state.creditCosts.credits > 0;
  if (startPlagiarismStatus) {
    let fileStatusCount = state.uploadedFilesStatus.filter(file => file.Status === "Ok")
    if (state.uploadedFiles.length !== fileStatusCount.length) {
      startPlagiarismStatus = 0;
    }
  }

  return (
    <div className={classes.root}>
      {openProjectsDialog && <ProjectsDialog openDialog={openProjectsDialog} closeDialog={closeProjectsDialog} handlesourceCheckbox={(isCheckedLibrarySources) => handlesourceCheckbox('checkedLibrarySources', isCheckedLibrarySources, 'lib')} />}
      {state.ui.autoAcceptSourcesDialogOpen && <AutoAcceptSourcesDialog />}
      {state.ui.autoExcludeSourcesDialogOpen && <AutoExcludeSourcesDialog />}
      {state.openCreateProjectPopup && <NewProjectForm />}
      <TitleBar title={state.newCheckSettings.revisionReportId ? s.newCheck.revisionCheckTitle : s.NewPlagCheck} />
      <div className={classes.main_container}>
        <div className={classes.selectSourcesPanel}>
          <ToggleButtonGroup orientation="vertical" value={state.newCheckSettings.source} exclusive onChange={changeToggleButton} className={classes.ToggleSourcesButtons}>
            {newPlagiarismTab.map(tab => {
              return (
                <ToggleButton key={tab.id} value={tab.id} aria-label={tab.id} classes={{ root: classes.toggleButtonSize, selected: classes.selectedToggleButton }} disabled={Boolean(state.newCheckSettings.revisionReportId) && tab.id == "library"}>
                  {tab.icon}
                  {s.newCheck[tab.id]}
                </ToggleButton>
              )
            })}
          </ToggleButtonGroup>
          <FormGroup >
            <div className={classes.centerAlign}>
              <FormControlLabel data-for="globalTT" data-tip={s.newCheck.addToLibraryTip}
                control={<Switch checked={state.newCheckSettings.addToLibrary}  onChange={e => addToLibrary(e.target.checked)} />}
                label={s.addText} />
            </div>
          </FormGroup>
        </div>
        <div className={classes.centerPanel}>
          <TextFieldPanel text={state.newCheckSettings.text} source={state.newCheckSettings.source} textChanged={textChanged} />
        </div>
        <div className={classes.detailsPanel}>
          <div className={classes.startSearchPanel}>
            <div className={classes.button_overlay}>
              <div className={classes.button}>
              <LoadingScreen status={loadingScreen} />
                <Button className={classes.button_size}
                  type="submit"
                  size="large"
                  variant="contained"
                  color="primary"
                  onClick={startPlagiarism}
                  endIcon={< SearchIcon />}
                  disabled={!startPlagiarismStatus || (state.resOfCalculatedCredit && state.resOfCalculatedCredit.data && state.user && state.user.credits < state.resOfCalculatedCredit.data.credits)}>
                  {s.startPlagiarism}
                </Button>
              </div>
              <div style={{ width: "100%", display: "flex", alignItems: "center", margin: 8 }}>
                <FormControlLabel data-for="globalTT" data-tip={state.newCheckSettings.revisionReportId && s.newCheck.revisionOnlineDisabled}
                  control={<Switch checked={state.newCheckSettings.searchWeb} onChange={(e) => handlesourceCheckbox('checkedOnlineSources', e.target.checked, 'web')} />}
                  label={<><PublicIcon className={classes.notInterestedIcon} /> {state.newCheckSettings.revisionReportId ? s.sourceIdentifiedSearch : s.sourceOnlineSearch}</>} />
              </div>
              <div style={{ width: "100%", display: "flex", alignItems: "center", margin: 8 }}>
                <FormControlLabel style={{ flex: "1 1 auto" }}
                  control={<Switch checked={state.newCheckSettings.searchLib}
                    onChange={(e) => handlesourceCheckbox('checkedLibrarySources', e.target.checked, 'lib')}
                  />}
                  label={<><LibraryBooksSharpIcon className={classes.notInterestedIcon} /> {((state.projects.length + 1) === state.newCheckSettings.searchInLibraryProjects.length || state.newCheckSettings.searchInLibraryProjects.length === 0) ? s.sourceLibrarySearch : s.sourceInNLibrarySearch.replace("#N#", state.newCheckSettings.searchInLibraryProjects.length)}</>} />
                <IconButton style={{ flex: "0 0 auto", marginRight: 16 }} onClick={() => setOpenProjectsDialog(true)}> <EditIcon fontSize="small" /></IconButton>
              </div>
              <CreditsPanel />
              {state.creditCosts && state.creditCosts.words != 0 ?
                <div className={classes.data}>
                  <div>
                    {s.newCheck.requiredCredits.format(state.creditCosts.words, state.creditCosts.pages, state.creditCosts.documents)}
                  </div>
                </div> :
                < div className={classes.data}>
                  <div>
                    {s.newCheck.requiredCredits.format(0, 0, 0)}
                  </div>
                </div>
              }
            </div>
          </div>
          <div className={classes.propertiesPanel}>
            <Accordion
              expanded={expanded === "panel1"}
              onChange={changePanel("panel1")}>
              <AccordionSummary
                className={classes.pannelSummary}
                aria-controls="panel1d-content"
                id="panel1d-header">
                {s.documentProperties}
              </AccordionSummary>
              <AccordionDetails className={classes.expansion_details}>
                <ReportPropertiesForm className={classes.update_padding} report={state.draftReport} validation={true} />
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel2"}
              onChange={changePanel("panel2")}
            >
              <AccordionSummary
                className={classes.pannelSummary}
                aria-controls="panel1d-content"
                id="panel1d-header">
                {s.automaticRating}
              </AccordionSummary>
              <AccordionDetails className={classes.expansion_details}>
                <div style={{ width: "100%" }}>
                  <div className={classes.alignInRow}>
                    <FormGroup style={{ flex: "1 1 auto" }}>
                      <FormControlLabel
                        control={<Switch checked={state.newCheckSettings.excludeUrlPatterns.length || state.newCheckSettings.excludeByWhitelist} onChange={e => handleAutoExcludeUrlsChecked(e.target.checked)} />}
                        label={<><NotInterestedIcon className={classes.notInterestedIcon} /> {s.excludeSources}</>} />
                    </FormGroup>
                    <IconButton onClick={() => dispatch(actions.setUI({ autoExcludeSourcesDialogOpen: true }))}>
                      <EditSharpIcon fontSize="small" />
                    </IconButton>
                  </div>
                  <div className={classes.alignInRow}>
                    <FormGroup style={{ flex: "1 1 auto" }}>
                      <FormControlLabel
                        control={<Switch checked={state.newCheckSettings.acceptUrlPatterns.length || state.newCheckSettings.acceptCitedUrls} onChange={e => handleAcceptCitedUrlsChecked(e.target.checked)} />}
                        label={<><CheckCircleIcon className={classes.checkCircleIcon} /> {s.acceptSources}</>} />
                    </FormGroup>
                    <IconButton onClick={() => dispatch(actions.setUI({ autoAcceptSourcesDialogOpen: true }))}>
                      <EditSharpIcon fontSize="small" />
                    </IconButton>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  )
}